import desktopImage from './desktop-image.jpg';
import mobileImage from './mobile-image.jpg';
import desktopVideo from './desktop-video.mp4';
import mobileVideo from './mobile-video.mp4';

export default { desktopImage, mobileImage, desktopVideo, mobileVideo };
